"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SLASH = exports.MOON = exports.DOT_OPERATOR = void 0;
var DOT_OPERATOR = exports.DOT_OPERATOR = '⋅';

/**
 * иконка месяца
 */
var MOON = exports.MOON = String.fromCharCode(9790);
var SLASH = exports.SLASH = String.fromCharCode(47);